import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
    const navigate = useNavigate();
    const [isInAppBrowser, setIsInAppBrowser] = useState(false);
    const [copied, setCopied] = useState(false);
    
    // Detect if user is in an in-app browser
    useEffect(() => {
        const userAgent = navigator.userAgent || '';
        const isInstagram = userAgent.includes('Instagram');
        const isFacebook = userAgent.includes('FBAN') || userAgent.includes('FBAV');
        const isSnapchat = userAgent.includes('Snapchat');
        const isTikTok = userAgent.includes('TikTok') || userAgent.includes('BytedanceWebview');
        const isTwitter = userAgent.includes('Twitter') || userAgent.includes('X Browser');
        
        setIsInAppBrowser(isInstagram || isFacebook || isSnapchat || isTikTok || isTwitter);
        
        // In-app browser detection (no logging needed)
    }, []);

    const handleGoogleClick = () => {
        navigate('/google-signup');
    };
    
    const handlePrivacyClick = () => {
        navigate('/privacy-policy');
    };
    
    const copyToClipboard = () => {
        const url = window.location.origin;
        navigator.clipboard.writeText(url)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };

    return (
        <div className="homepage-container">
            <div className="content-wrapper">
                <h3>Welcome to...</h3>
                <h1>DANNYTOPIA</h1>
                
                {/* Compact in-app browser warning */}
                {isInAppBrowser && (
                    <div className="browser-warning compact">
                        <p>In-app browser detected! For the best experience, copy this link and open in Safari/Chrome:</p>
                        <div className="copy-url-container">
                            <span className="url-text">{window.location.origin}</span>
                            <button 
                                className="copy-button"
                                onClick={copyToClipboard}
                            >
                                {copied ? '✓ Copied!' : 'Copy Link'}
                            </button>
                        </div>
                    </div>
                )}
                
                <div className={`app-description ${isInAppBrowser ? 'compact' : ''}`}>
                    <p>Dannytopia provides users access to art and tech with secure Google Sign-In. We only access basic profile info to manage your account.</p>
                </div>
                
                <div className="auth-buttons">
                    <button 
                        className="auth-button google-button"
                        onClick={handleGoogleClick}
                    >
                        Sign In/Up with Google
                    </button>
                    
                    <button 
                        className="auth-button privacy-button"
                        onClick={handlePrivacyClick}
                    >
                        Privacy Policy
                    </button>
                </div>
            </div>
            
            <footer className="homepage-footer">
                <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
                <span className="footer-copyright">© 2026 Moon Park LLC</span>
            </footer>
        </div>
    );
};

export default HomePage;